import { Injectable } from '@angular/core';
import { ServiceBase } from './service.base';
import { ICondicaoPagamento } from '../models/condicao-pagamento';
import { CondicoesPagamentoApi } from '../api/condicoes-pagamento.api';
import { ICondicaoPagamentoDTO } from '../dto/condicao-pagamento-dto';
import { MunicipiosApi } from '../api/municipios.api';
import { IMunicipio } from '../models/municipio';
import { IMunicipioDTO } from '../dto/municipio-dto';

@Injectable()
export class MunicipiosService extends ServiceBase<IMunicipio, IMunicipioDTO> {

    constructor(private api: MunicipiosApi) {
        super(api);
    }
}
